/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricing_Feature_Deep_ResearchInputs */

const en_landing_pricing_feature_deep_research = /** @type {(inputs: Landing_Pricing_Feature_Deep_ResearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In-depth AI research articles`)
};

const zh_landing_pricing_feature_deep_research = /** @type {(inputs: Landing_Pricing_Feature_Deep_ResearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI 深度调研长文`)
};

/**
* | output |
* | --- |
* | "In-depth AI research articles" |
*
* @param {Landing_Pricing_Feature_Deep_ResearchInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_pricing_feature_deep_research = /** @type {((inputs?: Landing_Pricing_Feature_Deep_ResearchInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricing_Feature_Deep_ResearchInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricing_feature_deep_research(inputs)
	return zh_landing_pricing_feature_deep_research(inputs)
});
export { landing_pricing_feature_deep_research as "landing.pricing.feature_deep_research" }